import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-mb-2 p-p-2" }
const _hoisted_2 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled" }
const _hoisted_3 = { class: "p-field p-col-12" }
const _hoisted_4 = { for: "batchClassId" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_FileSystem = _resolveComponent("FileSystem")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _component_FileSystemForm = _resolveComponent("FileSystemForm")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('Squeeze.BatchClasses.BatchClass')), 1),
          _createVNode(_component_Dropdown, {
            id: "batchClassId",
            modelValue: _ctx.batchClassId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batchClassId) = $event)),
            options: _ctx.batchClasses,
            loading: _ctx.loading,
            optionValue: "id",
            optionLabel: "description",
            onChange: _ctx.onChangeBatchClass
          }, null, 8, ["modelValue", "options", "loading", "onChange"])
        ])
      ]),
      _createVNode(_component_FileSystem, {
        files: _ctx.files,
        loading: _ctx.loading,
        documentClasses: _ctx.documentClasses,
        showErrorMessage: _ctx.showValidationMessage,
        onOnClickDelete: _ctx.openDeleteDialog,
        onOnEntrySelect: _ctx.onEntrySelect
      }, null, 8, ["files", "loading", "documentClasses", "showErrorMessage", "onOnClickDelete", "onOnEntrySelect"])
    ]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.deleteDialog,
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteDialog = false)),
      onOnConfirm: _ctx.deleteEntry
    }, null, 8, ["showDialog", "onOnConfirm"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showDialog,
      onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDialog = false, _ctx.isValidationInvalid = true, _ctx.showValidationMessage = false)),
      onOnConfirm: _ctx.saveFile,
      loading: _ctx.loadingDialog,
      headerText: _ctx.headerText,
      showKeepDialogOpen: !_ctx.file.id
    }, {
      content: _withCtx(() => [
        _createVNode(_component_BlockUI, { blocked: _ctx.loadingDialog }, {
          default: _withCtx(() => [
            _createVNode(_component_FileSystemForm, {
              file: _ctx.file,
              batchClassId: _ctx.file.batchClassId,
              batchClasses: _ctx.batchClasses,
              documentClasses: _ctx.documentClasses,
              onUpdate: _ctx.onUpdate,
              showErrorMessage: _ctx.showValidationMessage
            }, null, 8, ["file", "batchClassId", "batchClasses", "documentClasses", "onUpdate", "showErrorMessage"])
          ]),
          _: 1
        }, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "loading", "headerText", "showKeepDialogOpen"])
  ], 64))
}